import React, { useState, useCallback } from 'react'

import Button from 'components/Button'
import Modal from 'components/Modal'
import ModalActions from 'components/ModalActions'
import ModalTitle from 'components/ModalTitle'
import Spinner from 'react-svg-spinner'
import Label from 'components/Label'
import useApprove from 'hooks/useApprove'

const ApproveTransferModal = ({ onDismiss, ERC20TokenAddress }) => {
  const [requestedApproval, setRequestedApproval] = useState(false)
  const { onApprove } = useApprove()

  const handleApprove = useCallback(async () => {
    try {
      setRequestedApproval(true)
      const txHash = await onApprove(ERC20TokenAddress)
      setRequestedApproval(false)
      if (txHash) {
        onDismiss()
      }
    } catch (e) {
      console.log(e)
    }
  }, [onApprove, setRequestedApproval, ERC20TokenAddress, onDismiss])

  return (
    <Modal>
      <ModalTitle text="Approve to transfer" />
      {requestedApproval ? (
        <div style={{ width: '100%', textAlign: 'center' }}>
          <Spinner />
          <Label size="12" text="Waiting for the transaction" />
        </div>
      ) : (
        <></>
      )}
      <ModalActions>
        <Button
          disabled={requestedApproval}
          text="Approve"
          variant="secondary"
          onClick={handleApprove}
        />
      </ModalActions>
    </Modal>
  )
}

export default ApproveTransferModal
